// extracted by mini-css-extract-plugin
module.exports = {"Container":"empty-state-description_Container__NWpls"};